import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MobileLayout                   from '../layouts/MobileLayout';
import DashboardPage                  from '../pages/DashboardPage';
import DashboardStockDetailPage       from '../pages/DashboardStockDetailPage';
import DashboardPeriodDetailPage      from '../pages/DashboardPeriodDetailPage';
import TurnStatusPage                 from '../pages/TurnStatusPage';
import StockChartPage                 from '../pages/StockChartPage';
import QuickTradePage                 from '../pages/QuickTradePage';
import BalancePage                    from '../pages/BalancePage';

export default function MobileRoutes() {
  return (
    <Routes>
      {/* 기본 진입 → 대시보드 */}
      <Route index element={<Navigate to="dashboard" replace />} />

      {/* 대시보드 (메인) */}
      <Route path="dashboard" element={
        <MobileLayout><DashboardPage /></MobileLayout>
      } />

      {/* 대시보드 상세 페이지 (풀스크린, 탭바 없음) */}
      <Route path="dashboard/stock-detail"  element={<DashboardStockDetailPage />} />
      <Route path="dashboard/period-detail" element={<DashboardPeriodDetailPage />} />

      {/* 차수별현황 */}
      <Route path="turn-status" element={
        <MobileLayout><TurnStatusPage /></MobileLayout>
      } />

      {/* 시세 그래프 (풀스크린, 뒤로가기 헤더) */}
      <Route path="stock-chart" element={<StockChartPage />} />

      {/* 준비중 화면 */}
      <Route path="quick-trade" element={
        <MobileLayout><QuickTradePage /></MobileLayout>
      } />
      <Route path="balance" element={
        <MobileLayout><BalancePage /></MobileLayout>
      } />
    </Routes>
  );
}
